import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { drawDOM, exportImage, exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import {
  Chart,
  ChartArea,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartTitle,
  ChartTooltip,
  ChartValueAxis,
  ChartValueAxisItem,
} from "@progress/kendo-react-charts";
import { Window } from "@progress/kendo-react-dialogs";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import * as moment from "moment";
import React, { Component, PureComponent } from "react";
import { Dropdown } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import AddToCart from "../Tenant/AddToCart";
import ViewActionRiskDataset from "./ViewActionRiskDataset";
import TextNarrative from "./TextNarrative";
import SkeletonReport from "./SkeletonReport";
import TextNarrativeExport from "./TextNarrativeExport";
import ReportUpdate from "./ReportUpdate";

export default class BurnDownChartContainer extends Component {
  _chart;
  _chartTemp;
  _MailId;
  _Message;
  _Title;
  _expandFlag;
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      isReportLoaded:false,
      chartData:{}
    };
  }
  componentDidMount=()=>{
    if(this.props.dashboardId&&this.props.reportId&&!this.props.chartInputs){
      this.fetchReportsByPagination(this.props.dashboardId,this.props.reportId);
    }else{
      this.setState({
        chartData:this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded:true
      });
    }
   }
   fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData:response.chartData[0],
          isReportLoaded:true
        });
        this.props.updateResponse(reportId,response.chartData[0]);
      }else{
        this.setState({
          chartData:{},
          isReportLoaded:true
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData:{},
        isReportLoaded:true
      });
    }
  };
   onImageExportClick = () => {
     let widgetName = this.state.chartData
       ? this.state.chartData.widgetName
       : "bar-chart";
 
     let chartId = this.state.chartData.widgetId;
     let htmlId = "#c" + chartId;
     let gridElement = document.querySelector(htmlId);
     
     // 1. Find the .textnarrativeexport inside this chart
     let narrativeElement = gridElement.querySelector(".textnarrativeexport");
 
     if (narrativeElement) {
       // 2. Temporarily make it visible
       narrativeElement.style.display = "block";
 
       // 3. Assign new text value inside the <p> tag
       let pTag = narrativeElement.querySelector("p");
       if (pTag) {
         const narrativeText = this.state.chartData?.textNarrative || "";
         pTag.textContent = narrativeText;
       }
     }
     
     // 4. Create a temporary white background overlay
     const whiteBackground = document.createElement('div');
     whiteBackground.style.position = 'absolute';
     whiteBackground.style.top = '0';
     whiteBackground.style.left = '0';
     whiteBackground.style.width = '100%';
     whiteBackground.style.height = '100%';
     whiteBackground.style.backgroundColor = 'white';
     whiteBackground.style.zIndex = '-1';
     
     // Store original position style
     const originalPosition = gridElement.style.position;
     
     // Make the container positioned so the absolute overlay works
     gridElement.style.position = 'relative';
     
     // Add the white background to the container
     gridElement.appendChild(whiteBackground);
     
     // 5. Create a style element with comprehensive white background rules
     const styleElement = document.createElement('style');
     styleElement.textContent = `
       /* Target the specific container */
       #${gridElement.id} {
         background-color: white !important;
         color: black !important;
         position: relative !important;
       }
       
       /* Target all elements inside the container */
       #${gridElement.id} * {
         background-color: white !important;
         color: black !important;
       }
       
       /* Specific targeting for the dataset header which appears to have a black background */
       #${gridElement.id} .wgHeader {
         background-color: white !important;
         color: black !important;
         border: none !important;
         margin: 0 !important;
         padding: 10px !important;
       }
       
       #${gridElement.id} .wgHeader h4 {
         background-color: white !important;
         color: black !important;
         margin: 0 !important;
       }
       
       /* Target the text narrative area */
       #${gridElement.id} .textnarrativeexport {
         background-color: white !important;
         color: black !important;
         border: none !important;
         margin: 0 !important;
         padding: 10px !important;
       }
       
       #${gridElement.id} .textnarrativeexport p {
         background-color: white !important;
         color: black !important;
         margin: 0 !important;
       }
       
       /* Target any potential dividers or borders */
       #${gridElement.id} hr,
       #${gridElement.id} .divider {
         background-color: white !important;
         border-color: white !important;
       }
       
       /* Preserve chart colors */
       #${gridElement.id} .mitigated { background-color: rgb(248, 220, 135) !important; }
       #${gridElement.id} .unmitigated { background-color: rgb(255, 138, 130) !important; }
       #${gridElement.id} .mitigatedend { background-color: rgb(255, 210, 70) !important; }
       #${gridElement.id} .umitigatedend { background-color: rgb(255, 99, 88) !important; }
       #${gridElement.id} .originalCompletionDate { background-color: rgb(206,237,248) !important; }
       #${gridElement.id} .projectedCompletionDate { background-color: rgb(227, 241, 22) !important; }
       #${gridElement.id} .actualCompletionDate { background-color: rgb(34,159,204) !important; }
       #${gridElement.id} .currentValue { background-color: rgb(8, 77, 167) !important; }
     `;
     
     // Add the style element to the document head
     document.head.appendChild(styleElement);
     
     // 6. Export immediately
     drawDOM(gridElement, { background: "white" })
       .then((group) => exportImage(group, { background: "white" }))
       .then((dataURI) => {
         saveAs(dataURI, widgetName + ".png");
       })
       .finally(() => {
         // 7. Clean up - remove the white background overlay
         try {
           gridElement.removeChild(whiteBackground);
         } catch (e) {
           console.error("Error removing white background:", e);
         }
         
         // 8. Restore original position
         gridElement.style.position = originalPosition;
         
         // 9. Remove the style element
         try {
           document.head.removeChild(styleElement);
         } catch (e) {
           console.error("Error removing style element:", e);
         }
         
         // 10. Hide the narrative element again
         if (narrativeElement) {
           narrativeElement.style.display = "none";
           let pTag = narrativeElement.querySelector("p");
           if (pTag) {
             pTag.textContent = ""; // clear the text if needed
           }
         }
       });
   };

  onPDFExportClick = (flag) => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Burdown-chart";
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);

    //================ Export Narrative Start =========================
    // 1. Find the .textnarrativeexport inside this chart
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");

    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }
    //================ Export Narrative End ===========================

    //================ transparency Start ===========================

    // Function to recursively set background to transparent for all elements
    const makeTransparent = (element, originalStyles, prefix) => {
      // Store original background
      originalStyles[`${prefix}_bg`] = element.style.backgroundColor;
      originalStyles[`${prefix}_bgImg`] = element.style.backgroundImage;

      // Set background to transparent
      element.style.backgroundColor = "transparent";
      element.style.backgroundImage = "none";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        makeTransparent(child, originalStyles, `${prefix}_${index}`);
      });

      return originalStyles;
    };

    // Function to restore original backgrounds
    const restoreBackgrounds = (element, originalStyles, prefix) => {
      // Restore background
      element.style.backgroundColor = originalStyles[`${prefix}_bg`] || "";
      element.style.backgroundImage = originalStyles[`${prefix}_bgImg`] || "";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        restoreBackgrounds(child, originalStyles, `${prefix}_${index}`);
      });
    };

    // Store original styles and make all elements transparent
    const originalStyles = {};
    makeTransparent(gridElement, originalStyles, "root");

    // Add a temporary style tag with aggressive selectors
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      #${gridElement.id},
      #${gridElement.id} *,
      #${gridElement.id} *::before,
      #${gridElement.id} *::after {
        background-color: transparent !important;
        background-image: none !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
        align-items: center;
        padding: 12px 5px 0px 5px;
      }
        /* Put these AFTER the global transparency override */
  #${gridElement.id} .originalCompletionDate {
    background-color: rgb(206, 237, 248) !important;
  }

  #${gridElement.id} .projectedCompletionDate {
    background-color: rgb(227, 241, 22) !important;
  }

  #${gridElement.id} .actualCompletionDate {
    background-color: rgb(34, 159, 204) !important;
  }

      .textnarrativeexport {
        color: black !important;
        font-size: 12px;
        font-family: "Barlow";
        src: url("./riskwell/Assets/Fonts/Barlow-Medium.ttf");
        font-style: normal;
       
      }
      /* Target specific Kendo chart elements */
      .k-chart-surface,
      .k-chart-area,
      .k-chart svg,
      .k-chart svg rect,
      .k-chart-plot-area,
      .k-chart-pane {
        background-color: transparent !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
    `;
    document.head.appendChild(styleTag);

    // If this is a Kendo chart, try to update its options directly
    if (this._chart && typeof this._chart.setOptions === "function") {
      try {
        const currentOptions = this._chart.options || {};
        this._chart.setOptions({
          ...currentOptions,
          chartArea: {
            ...currentOptions.chartArea,
            background: "transparent",
          },
          plotArea: {
            ...currentOptions.plotArea,
            background: "transparent",
          },
        });
      } catch (e) {
        console.error("Error updating chart options:", e);
      }
    }

    // Force a repaint
    gridElement.style.display = "none";
    void gridElement.offsetHeight;
    gridElement.style.display = "";
    //================ transparency End ===========================

    // setTimeout(async () => {
    drawDOM(gridElement, {
      // landscape: false,
      title: this.state.title + " " + CreatedDate,
      background: "transparent",
      // paperSize: "auto",
      // margin: "1cm",
      // scale: 0.8,
      // forcePageBreak: ".page-break",
    })
      .then((group) => {
        // Try to modify the group to ensure transparency
        try {
          if (group && group.children) {
            group.children.forEach((child) => {
              if (child.options) {
                child.options.background = "transparent";
              }
            });
          }
        } catch (e) {
          console.error("Error modifying group:", e);
        }

        return exportPDF(group, {
          background: "transparent",
          // paperSize: "auto",
          // margin: "1cm",
          // landscape: true,
        });
      })
      .then((dataURI) => {
         if (flag === "MAIL") {
                          this.sendMail(dataURI, chartId);
                        }else{
                          saveAs(dataURI, widgetName + ".pdf");
                        }
      })
      .catch((error) => {
        console.error("PDF export error:", error);
      })
      .finally(() => {
        // Clean up - remove the style tag
        document.head.removeChild(styleTag);

        // Restore original backgrounds
        restoreBackgrounds(gridElement, originalStyles, "root");

        // If we modified the chart options, try to restore them
        if (this._chart && typeof this._chart.setOptions === "function") {
          try {
            this._chart.refresh();
          } catch (e) {
            console.error("Error refreshing chart:", e);
          }
        }

        if (narrativeElement) {
          // 5. After export, remove the temporary text or hide the element
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
    // }, 1000);

    // this.pdfTitlePopupClose();
  };
  openWidgetDeletePopup = () => {
    if(!this.props.isFreezeDS){
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId||this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };
  changeLineChartWidth = (widgetId) => {
    this._expandFlag=true;
    this.props.changeLineChartWidth(widgetId);
  };
  editWidget = (data) => {
    if (data.isActionWidget) {
      this.refs.childWidget.editWidgetdOpen("MITI", data);
    } else {
      this.refs.childWidget.editWidgetdOpen("RISK", data);
    }
  };

  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  shareFile = (widgetId) => {
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    setTimeout(async () => {
      drawDOM(gridElement, {
        landscape: true,
        title: this.state.title + " " + CreatedDate,
      })
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataURI) => {
          this.sendMail(dataURI, widgetId);
        });
    }, 1000);
  };

  sendMail = async (dataURL, widgetId) => {
    //var dataURL = canvas.toDataURL('image/jpeg', 0.5);
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Bar-chart";
    var blob = this.dataURLtoFile(dataURL, widgetName + ".pdf");
    var fd = new FormData(document.forms[0]);
    fd.append("file", blob);
    fd.append("mailId", this._MailId);
    fd.append("message", this._Message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false, emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };

  refreshDashboard = (flag) => {
    this.props.refreshDashboard(flag);
  };

  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Widget",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }
  ViewDataSet = () => {
    this.setState({
      visible: true,
    });
  };
  closeToggleClose = () => {
    this.setState({
      visible: false,
    });
  };

  formatYaxisValue = (e) => {
    if (this.isFloat(e.value)) {
      return "";
    } else {
      return formatNumber(Number(e.value), "##,#");
    }
  };
  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative&&this.props.refreshTextNarative(text, widgetId);
  };
  handleChartRefresh=(chartOptions, themeOptions, chartInstance)=>{
    if (!this.state.isReportLoaded) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
    if(this._expandFlag===true){
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  }
   CustomTooltip = (props) => {
    const { categoryText, points } = props;
    const date = moment(categoryText).format('DD-MMM-yyyy');
  
    return (
      <div>
        <strong>{date}</strong>
        {points.map((point, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {/* Color box */}
            <span
              style={{
                backgroundColor: point.series.color,
                width: 10,
                height: 10,
                borderRadius: '50%',
                display: 'inline-block'
              }}
            ></span>
            {/* Label and value */}
            <span>
            {point.series.name}: <strong>{point.value}</strong>
          </span>
          </div>
        ))}
      </div>
    );
  };
   editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const chartData = this.state.chartData ? this.state.chartData : {};
    // const labelContent = (e) => (e.value.slice(0, 15));
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");
    const startDate = moment(chartData.startDate).format("DD-MMM-yyyy");
    const endDate = moment(chartData.endDate).format("DD-MMM-yyyy");
    var xAxisDate = chartData?.axes?.xAxes.map((e) => {
      // const [day, month, year] = e.split('-');
      // return (new Date(`${day}-${month}-${year}`));
      return new Date(e);
    });
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    }
    else if(chartData.isCustomFieldDeleted||chartData.isImpactDeleted){
      return (
        <div>
           <ul className="WidgetActions">
           {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId) ? (
                !this.props.isFreezeDS && (
                                    <li onClick={this.openWidgetDeletePopup}>
                                      <a className="bgRed">
                                        <img src={Images.TRASH} alt="Trash" width="13" />
                                      </a>
                                    </li>
                                  )
              ) : (
                ""
              )}
           </ul>
          <h4 className="wgTitle">
          Associated Dataset's Impact/Custom fields might been deleted or revoked
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    }else if(chartData.notValidPrimeDataset){
      return (
        <div>
           <ul className="WidgetActions">
           {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId) ? (
                !this.props.isFreezeDS && (
                                    <li onClick={this.openWidgetDeletePopup}>
                                      <a className="bgRed">
                                        <img src={Images.TRASH} alt="Trash" width="13" />
                                      </a>
                                    </li>
                                  )
              ) : (
                ""
              )}
           </ul>
          <h4 className="wgTitle">
            Cannot load report as Prime settings have been changed for Workstream.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>

        </div>
      );
    }else if(chartData.isTaskModuleDisabled){
          return (
            <div>
               <ul className="WidgetActions">
               {this.props.isTenentAdmin ||
                  chartData.createdBy == userId ||
                  (this.props.selectedDashboard &&
                    this.props.selectedDashboard.createdBy == userId) ? (
                      !this.props.isFreezeDS && (
                        <li onClick={this.openWidgetDeletePopup}>
                          <a className="bgRed">
                            <img src={Images.TRASH} alt="Trash" width="13" />
                          </a>
                        </li>
                      )
                  ) : (
                    ""
                  )}
               </ul>
              <h4 className="wgTitle">
              Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator.
              </h4>
              <Popup
                show={this.state.openDeleteModelFlag}
                popupClass={"popup-content"}
              >
                {this._Loader ? (
                  <span className="MatTableSpinner">
                    <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                  </span>
                ) : null}
                <div className="deleteModelCont">
                  <h3>Are you sure you want to delete this report?</h3>
                  <div className="btnCont">
                    <button
                      onClick={() => this.removeWidget(chartData)}
                      className="deleteBtn"
                      type="button"
                    >
                      Yes
                    </button>
                    <button
                      onClick={this.closeWidgetDeletePopup}
                      className="cancelBtn"
                      type="button"
                    >
                      No
                    </button>
                  </div>
                </div>
              </Popup>
    
            </div>
          );
        }else{
    return (
      <div>
        {this.state.visible && (
          <Window
            title={chartData.dataSource}
            onClose={this.closeToggleClose}
            className="statusWindow"
            initialLeft={350}
            initialTop={200}
            initialWidth={1000}
            initialHeight={300}
          >
            <div className="tblCont dataGrids">
              <ViewActionRiskDataset
                chartData={chartData}
                isFreezeDS={this.props.isFreezeDS}
              ></ViewActionRiskDataset>
            </div>
          </Window>
        )}
        {this.props.expandIcon && (
          <div className="expandView">
            <a
              className="expand"
              onClick={() => this.changeLineChartWidth(chartData.widgetId)}
            >
              <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
            </a>
            <a
              className="shrink"
              onClick={() => this.changeLineChartWidth(chartData.widgetId)}
            >
              <img src={Images.SHRINK} alt="Expand" width="10" />
            </a>
          </div>
        )}
        {this.props.viewDataSetIcon && (
          <ul className="viewDataset WidgetActions">
            <li
              title="View Dataset"
              onClick={() => this.ViewDataSet(chartData)}
            >
              <a>
                <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
              </a>
            </li>
          </ul>
        )}
        {this.props.flag ? (
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
            chartData.createdBy == userId ||
            (this.props.selectedDashboard &&
              this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                  <li onClick={() => this.editWidgetOpen(chartData)}>
                    <a>
                      <img src={Images.EDITICON} alt="Edit" width="14" />
                    </a>
                  </li>
                )
              : ""}
            <TextNarrative
              chartInputs={chartData}
              refreshTextNarative={this.refreshTextNarative}
              isFreezeDS={this.props.isFreezeDS}
            />
            <li
              title="View Dataset"
              onClick={() => this.ViewDataSet(chartData)}
            >
              <a>
                <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
              </a>
            </li>
            {this.props.isFreezeDS ? (
              ""
            ) : (
              <li
                title="Add to home"
                onClick={() => this.moveToHome(chartData)}
              >
                <a>
                  <img src={Images.HOME} alt="Download" width="14" />
                </a>
              </li>
            )}
            {/* {chartData.createdBy == userId && (
              <li onClick={() => this.editWidget(chartData)}>
                <a>
                  <img src={Images.EDITICON} alt="Download" width="14" />
                </a>
              </li>
            )} */}
            <li title="PNG Download" onClick={this.onImageExportClick}>
              <a>
                <img src={Images.DOWNLOAD} alt="Download" width="14" />
              </a>
            </li>
            <li title="PDF Download" onClick={this.onPDFExportClick}>
              <a>
                <img src={Images.PDF} alt="Download" width="14" />
              </a>
            </li>
            {this.props.isFreezeDS ? (
              ""
            ) : (
              <li
                title="Share"
                onClick={() => this.openAddToCart(chartData.widgetId)}
              >
                <a>
                  <img src={Images.SHARE} alt="Download" width="14" />
                </a>
              </li>
            )}
            <li>
              <Dropdown
                menuAlign="right"
                title="Mail"
                id="dropdown-menu-align-right"
              >
                <Dropdown.Toggle>
                  <a>
                    <img src={Images.MAIL} alt="Share" width="14" />
                  </a>
                </Dropdown.Toggle>
                <Dropdown.Menu className="filterList emailBox">
                  <div className="filterBox">
                    <div className="dateRange">
                      <div className="dateCont">
                        <h6>Email</h6>
                        <input
                          type="email"
                          autoComplete="off"
                          onChange={(e) => (this._MailId = e.target.value)}
                        />
                      </div>
                      <div className="dateCont">
                        <h6>Message</h6>
                        <textarea
                          autoComplete="off"
                          onChange={(e) => (this._Message = e.target.value)}
                        ></textarea>
                        <Dropdown.Item
                          as="button"
                          onClick={() => this.onPDFExportClick("MAIL")}
                        >
                          SEND
                        </Dropdown.Item>
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </li>

            {this.props.isTenentAdmin ||
            chartData.createdBy == userId ||
            (this.props.selectedDashboard &&
              this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                  <li onClick={this.openWidgetDeletePopup}>
                    <a className="bgRed">
                      <img src={Images.TRASH} alt="Trash" width="13" />
                    </a>
                  </li>
                )
              : ""}
          </ul>
        ) : (
          <ul className="WidgetActions">
            {/* <li title="Remove from home" onClick={() => this.removeFromHome(chartData)}>
                <a>
                  <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
                </a>
              </li> */}
          </ul>
        )}

        <div id={"c" + chartData.widgetId} key={chartData.title}>
          {/* <small className="createdDate">{CreatedDate}</small> */}

          <div>
            <Chart
              pannable={{
                lock: "y",
              }}
              zoomable={{
                mousewheel: {
                  lock: "y",
                },
              }}
              ref={(cmp) => ((this._chart = cmp), (this._chartTemp = cmp))}
              onRefresh={this.handleChartRefresh}
            >
              <ChartTooltip
                shared={true}
                render={this.CustomTooltip}
                sharedTooltipRender={true}
                SharedTooltip={true}
                // render={({ point }) => {
                //   const formattedDate = new Date(point.category).toLocaleDateString();
                //   return (
                //     <div>
                //       <strong>Date:</strong> {formattedDate}<br />
                //       <strong>Value:</strong> {point.value}
                //     </div>
                //   );
                // }}
              />
              <ChartArea background="transparent" margin={(0, 20)} />
              <ChartTitle
                text={chartData.title ? chartData.title : ""}
                color="#b5b5b5"
              />

              <ChartLegend position="bottom" />
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={xAxisDate}
                  color="#919191"
                  labels={{
                    format: "dd-MMM-yyyy",
                    rotation: "auto",
                  }}
                  maxDivisions={30}
                  //baseUnitStep="auto"
                  // maxDivisions={30}
                  //labels={{
                  // format: "d",
                  // rotation: "auto",
                  //  content: labelContent
                  // }}
                />
              </ChartCategoryAxis>
              <ChartSeries>
                {/* {chartData.yAxes&&chartData.yAxes.map((item, idx) => ( */}
                <ChartSeriesItem
                  type="area"
                  style="smooth"
                  // data={item.data}
                  data={chartData?.axes?.yAxis3 ? chartData?.axes?.yAxis3 : []}
                  tooltip={{ visible: true }}
                  //opacity={0.5}
                  color="rgb(34,159,204)"
                />

                <ChartSeriesItem
                  type="area"
                  style="smooth"
                  // data={item.data}
                  data={chartData?.axes?.yAxis2 ? chartData?.axes?.yAxis2 : []}
                  tooltip={{ visible: true }}
                  //opacity={0.3}
                  color="rgb(227, 241, 22)"
                />
                <ChartSeriesItem
                  type="area"
                  style="smooth"
                  // data={item.data}
                  data={chartData?.axes?.yAxis1 ? chartData?.axes?.yAxis1 : []}
                  tooltip={{ visible: true }}
                  //opacity={0.05}
                  color="rgb(206,237,248)"
                />

                {/* // ))} */}
              </ChartSeries>

              <ChartValueAxis skip={4}>
                <ChartValueAxisItem
                  color="#919191"
                  skip={2}
                  title={{ text: chartData?.yName }}
                  labels={{ content: this.formatYaxisValue }}
                />
              </ChartValueAxis>
            </Chart>
            <div>
              <h5 className="wgTitle">
                <span className="actualCompletionDate"></span> Actual Completion
                Date
              </h5>
              <h5 className="wgTitle">
                <span className="projectedCompletionDate"></span> Projected
                Completion Date
              </h5>
              <h5 className="wgTitle">
                <span className="originalCompletionDate"></span> Original
                Completion Date
              </h5>
            </div>
          </div>

          <div className="wgHeader">
            <h4>Dataset: {chartData.dataSource} </h4>
          </div>
          <TextNarrativeExport
            chartData={chartData}
            isHidden={this.state.isHidden}
          />
        </div>
        <ReportUpdate
          chartData={chartData}
          ref="childUpdateWidget"
          updateChartData={this.updateChartData}
        />

        <Popup
          show={this.state.openDeleteModelFlag}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this report?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.removeWidget(chartData)}
                className="deleteBtn"
                type="button"
              >
                Yes
              </button>
              <button
                onClick={this.closeWidgetDeletePopup}
                className="cancelBtn"
                type="button"
              >
                No
              </button>
            </div>
          </div>
        </Popup>

        <Popup show={this.state.openPdfTitlePopup} popupClass={"popup-content"}>
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}

          <div className="addTypeForm">
            <div className="fieldCont">
              <label>Enter Title</label>
              <input
                type="text"
                onChange={(e) => this.setState({ title: e.target.value })}
                placeholder="Title"
                value={this.state.title}
                required
              />
            </div>
            <div className="btnGroup">
              <button
                disabled={!this.state.title}
                className="btnPrimary"
                onClick={this.onPDFExportClick}
              >
                Export
              </button>
              <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
          <AddToCart
            {...this.props}
            closeAddToCart={() => this.closeAddToCart()}
            cartViewDetailsId={this.state.cartViewDetails}
            cartViewType={this.state.cartViewType}
          />
        </Popup>
      </div>
    );
          }
  }
}
// export default withRouter(LineChartContainer);
// ReactDOM.render(<ChartContainer />, document.querySelector("my-app"));
